<template>
  <GridComponent
    id="managementList"
    ref="_grid"
    :data-source="_dataManager"
    :allow-paging="true"
    width="auto"
    :allow-reordering="true"
    :allow-resizing="true"
    :show-column-menu="false"
    :allow-text-wrap="true"
    :row-selected="onRowSelected"
    :row-deselected="onRowDeselected"
    :page-settings="_pageSettings"
  >
    <ColumnsDirective>
      <ColumnDirective
        field="cancelationStatusDescription"
        header-text="status"
        :auto-fit="true"
      />
      <ColumnDirective
        field="personName"
        header-text="Kunde"
        :auto-fit="true"
      />
      <ColumnDirective
        field="cancelationOrderNumber"
        header-text="Rechnungsnummer"
        :auto-fit="true"
      />
      <ColumnDirective
        field="cancelationOrderedDate"
        header-text="Rechnungsdatum"
        :auto-fit="true"
        format="dd.MM.yyyy"
        type="dateTime"
      />
      <ColumnDirective
        field="count"
        header-text="Anzahl"
        :auto-fit="true"
      />
    </ColumnsDirective>
  </GridComponent>
</template>

<script setup lang="ts">
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import {Api} from "@/shared/services/api";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import {ref} from "vue";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import InsuranceCancelation from "@/shared/model/InsuranceCancelation";


const _url = Api.baseUrl + '/InsuranceCancelationGroupList';
const _adaptor = new CustomAdaptor()
const _grid = ref<InstanceType<typeof GridComponent> | null>(null)

const _pageSettings = {pageSize: 50, pageSizes: ["All", 10, 25, 50, 100]}


const _dataManager = new DataManager({
  url: _url,
  adaptor: _adaptor,
  crossDomain: true,
})

const _emit = defineEmits<{ (e: 'selected', insuranceCancelation?: InsuranceCancelation): void }>()

function onRowSelected(args: any) {
  _emit("selected", args.data as InsuranceCancelation)
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _emit("selected", undefined)
}

function refresh() {
  _grid.value?.refresh()
}

defineExpose({
  adaptor: _adaptor, refresh
})
</script>

<style scoped>

</style>